import React, { useState, Children, memo } from 'react';
import { ChevronDown, ChevronRight, Phone, Menu, X, ShoppingCart, User, Sparkles, Bath, Brain, Baby, Apple, Zap, Eye, Wheat, Heart, Leaf, Home, Shield, Gem, Pill, Droplet, CircleDot, Sparkle, Dumbbell, Scale, Sprout, Salad, BoxIcon } from 'lucide-react';
type Category = {
  name: string;
  url: string;
  icon: BoxIcon;
};
type NavItem = {
  name: string;
  url: string;
};
const productCategories: Category[] = [{
  name: 'Anti-Aging Vitamins',
  url: 'https://www.bestvitaminsforall.com/bestantiagingvitamins',
  icon: Sparkles
}, {
  name: 'Body Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-body-care-products.html',
  icon: Bath
}, {
  name: 'Memory Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-brain-memory-supplements.html',
  icon: Brain
}, {
  name: 'Children Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-children-supplements.html',
  icon: Baby
}, {
  name: 'Digestion Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-digestion-supplements.html',
  icon: Apple
}, {
  name: 'Energy Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-energy-vitamins-supplements.html',
  icon: Zap
}, {
  name: 'Eyes & Vision',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-eyes-vision.html',
  icon: Eye
}, {
  name: 'Fiber Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-fiber-supplements.html',
  icon: Wheat
}, {
  name: 'Heart Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-heart-supplements.html',
  icon: Heart
}, {
  name: 'Herbal Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-herbal-supplements.html',
  icon: Leaf
}, {
  name: 'Home Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-home-care-products.html',
  icon: Home
}, {
  name: 'Immune Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-immune-supplements.html',
  icon: Shield
}, {
  name: 'Mineral Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-mineral-supplements.html',
  icon: Gem
}, {
  name: 'Multi-Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-multi-vitamins.html',
  icon: Pill
}, {
  name: 'Natural Oils',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-natural-oils.html',
  icon: Droplet
}, {
  name: 'Single Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-single-vitamins.html',
  icon: CircleDot
}, {
  name: 'Skin Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-skin-care.html',
  icon: Sparkle
}, {
  name: 'Sports Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-sports-supplements.html',
  icon: Dumbbell
}, {
  name: 'Vegan Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegan-vitamins-supplements.html',
  icon: Sprout
}, {
  name: 'Vegetarian Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegetarian-supplements.html',
  icon: Salad
}, {
  name: 'Weight Loss Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-weight-loss-supplements.html',
  icon: Scale
}, {
  name: 'Protein Shakes',
  url: 'https://www.bestvitaminsforall.com/15m8/neolife-protein-shakes.html',
  icon: BoxIcon
}, {
  name: 'Organic Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/organic-vitamins.html',
  icon: Leaf
}];
type ResourceCategory = {
  name: string;
  links: NavItem[];
};
const resourceCategories: ResourceCategory[] = [{
  name: 'Supplement Education',
  links: [{
    name: 'How Whole-Food Supplements Are Different',
    url: 'https://www.bestvitaminsforall.com/how-whole-food-supplements-are-different'
  }, {
    name: 'Synthetic vs Whole-Food Vitamins: What to Know',
    url: 'https://www.bestvitaminsforall.com/synthetic-vs-whole-food-vitamins-what-to-know'
  }, {
    name: 'Understanding Vitamin Absorption & Bioavailability',
    url: 'https://www.bestvitaminsforall.com/understanding-vitamin-absorption-bioavailability'
  }, {
    name: 'Why Formulation Matters More Than Dosage',
    url: 'https://www.bestvitaminsforall.com/why-formulation-matters-more-than-dosage'
  }, {
    name: 'Common Supplement Myths and Misconceptions',
    url: 'https://www.bestvitaminsforall.com/common-supplement-myths-and-misconceptions'
  }]
}, {
  name: 'Nutrition & Body Systems',
  links: [{
    name: 'Nutrition for Brain & Cognitive Health',
    url: 'https://www.bestvitaminsforall.com/nutrition-for-brain-cognitive-health'
  }, {
    name: 'How Nutrition Supports Immune Health',
    url: 'https://www.bestvitaminsforall.com/how-nutrition-supports-immune-health'
  }, {
    name: 'Supporting Heart & Circulatory Health Through Nutrition',
    url: 'https://www.bestvitaminsforall.com/supporting-heart-circulatory-health-through-nutrition'
  }, {
    name: 'Digestive Health and Nutrient Absorption',
    url: 'https://www.bestvitaminsforall.com/digestive-health-and-nutrient-absorption'
  }, {
    name: 'Cellular Health, Oxidative Stress, and Aging',
    url: 'https://www.bestvitaminsforall.com/cellular-health-oxidative-stress-and-aging'
  }]
}, {
  name: 'Life Stages & Wellness',
  links: [{
    name: 'Supporting Wellness as We Age',
    url: 'https://www.bestvitaminsforall.com/supporting-wellness-as-we-age'
  }, {
    name: 'Foundational Nutrition for Children - Educational Resource',
    url: 'https://www.bestvitaminsforall.com/foundational-nutrition-for-children-educational-resource'
  }, {
    name: 'Nutrition for Active and Athletic Lifestyles — Informational Resource',
    url: 'https://www.bestvitaminsforall.com/nutrition-for-active-and-athletic-lifestyles-—-informational-resource'
  }, {
    name: 'Daily Nutrition for Busy Adults',
    url: 'https://www.bestvitaminsforall.com/daily-nutrition-for-busy-adults'
  }, {
    name: 'Building Resilience Through Nutrition at Every Stage of Life',
    url: 'https://www.bestvitaminsforall.com/building-resilience-through-nutrition-at-every-stage-of-life'
  }]
}, {
  name: 'Daily Wellness Foundations',
  links: [{
    name: 'Building a Simple Daily Supplement Routine',
    url: 'https://www.bestvitaminsforall.com/building-a-simple-daily-supplement-routine'
  }, {
    name: 'Filling Common Nutrition Gaps in Modern Diets',
    url: 'https://www.bestvitaminsforall.com/filling-common-nutrition-gaps-in-modern-diets'
  }, {
    name: 'Nutrition, Lifestyle, and Long-Term Vitality',
    url: 'https://www.bestvitaminsforall.com/nutrition-lifestyle-and-long-term-vitality'
  }, {
    name: 'Whole Nutrition as a Foundation for Wellness',
    url: 'https://www.bestvitaminsforall.com/whole-nutrition-as-a-foundation-for-wellness'
  }, {
    name: 'Consistency, Quality, and Long-Term Results',
    url: 'https://www.bestvitaminsforall.com/consistency-quality-and-long-term-results'
  }]
}, {
  name: 'Ingredients & Nutrients',
  links: [{
    name: 'Understanding Antioxidant Nutrients',
    url: 'https://www.bestvitaminsforall.com/understanding-antioxidant-nutrients'
  }, {
    name: 'Essential Fatty Acids and Their Role in Wellness',
    url: 'https://www.bestvitaminsforall.com/essential-fatty-acids-and-their-role-in-wellness'
  }, {
    name: 'Minerals and Micronutrients Explained',
    url: 'https://www.bestvitaminsforall.com/minerals-and-micronutrients-explained'
  }, {
    name: 'Plant-Based Nutrients and Phytonutrients',
    url: 'https://www.bestvitaminsforall.com/plant-based-nutrients-and-phytonutrients'
  }, {
    name: 'Why Balance Matters in Nutrient Intake',
    url: 'https://www.bestvitaminsforall.com/why-balance-matters-in-nutrient-intake'
  }]
}];
const directResourceLinks: NavItem[] = [{
  name: 'NeoLife Blog',
  url: '/blog'
}, {
  name: 'NeoLife Reviews',
  url: '/reviews'
}, {
  name: 'Why Choose NeoLife Products',
  url: '/neolife'
}];
const joinItems: NavItem[] = [{
  name: 'Join',
  url: '/joingnldmembers'
}, {
  name: 'Become a Distributor',
  url: '/gnld-Neolife-distributors'
}];
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [mobileExpandedSection, setMobileExpandedSection] = useState<string | null>(null);
  const [activeResourceCategory, setActiveResourceCategory] = useState<string | null>(null);
  const [mobileExpandedResourceCategory, setMobileExpandedResourceCategory] = useState<string | null>(null);
  // Split categories into columns for desktop (4 columns)
  const columnsCount = 4;
  const itemsPerColumn = Math.ceil(productCategories.length / columnsCount);
  const columns: Category[][] = [];
  for (let i = 0; i < columnsCount; i++) {
    columns.push(productCategories.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn));
  }
  const handleDropdownEnter = (menu: string) => setActiveDropdown(menu);
  const handleDropdownLeave = () => setActiveDropdown(null);
  const toggleMobileSection = (section: string) => {
    setMobileExpandedSection(mobileExpandedSection === section ? null : section);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50 font-sans" data-id="element-90">
      {/* Promotional Announcement Bar */}
      <div className="bg-[#1a8f3c] text-white py-2.5 px-4 text-center" data-id="element-91">
        <p className="text-sm md:text-[13px] font-medium leading-snug" data-id="element-92">
          <span className="font-bold" data-id="element-93">
            Get a FREE NeoLife Membership & Save up to 25% on ALL supplements
          </span>
          <span className="hidden sm:inline" data-id="element-94"> | </span>
          <br className="sm:hidden" data-id="element-95" />
          <span className="text-white/90" data-id="element-96">
            Scientifically formulated supplements that deliver real results
          </span>
        </p>
      </div>

      {/* Top Bar - Mobile Only */}
      <div className="md:hidden bg-[#0e7be1] text-white py-2 px-4 text-center text-sm font-medium" data-id="element-97">
        Call us: 800-260-2808
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <div className="flex justify-between items-center h-14 lg:h-16" data-id="element-99">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-3" data-id="element-100">
            <a href="/" className="flex items-center" data-id="element-101">
              <img src="https://cdn.magicpatterns.com/uploads/1hCDA3zzdjWRL7TqBKyeWc/Best-Vitamins-For-All.webp" alt="Best Vitamins For All" className="h-6 lg:h-7 w-auto" data-id="element-102" />
            </a>
            <img src="https://cdn.magicpatterns.com/uploads/ssrgMdZGi9uTcmdb8AVR45/GNLD-secondary-logo.webp" alt="GNLD NeoLife" className="h-8 lg:h-10 w-auto" data-id="element-103" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6" data-id="element-104">
            {/* Products Dropdown */}
            <div className="relative" onMouseEnter={() => handleDropdownEnter('products')} onMouseLeave={handleDropdownLeave} data-id="element-105">
              <button className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium inline-flex items-center transition-colors" data-id="element-106">
                Products
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${activeDropdown === 'products' ? 'rotate-180' : ''}`} data-id="element-107" />
              </button>
              <div className={`absolute left-1/2 -translate-x-1/2 mt-0 pt-2 transition-all duration-150 ${activeDropdown === 'products' ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`} data-id="element-108">
                <div className="bg-white shadow-xl ring-1 ring-gray-200 rounded-lg overflow-hidden min-w-[750px]" data-id="element-109">
                  <div className="p-6" data-id="element-110">
                    <div className="grid grid-cols-4 gap-x-8 gap-y-1" data-id="element-111">
                      {columns.map((column, colIndex) => <div key={colIndex} className="space-y-1" data-id="element-112">
                          {column.map(category => {
                        const Icon = category.icon;
                        return <a key={category.name} href={category.url} className="flex items-center gap-2 py-2 text-sm text-gray-600 hover:text-[#0e7be1] transition-colors whitespace-nowrap" data-id="element-113">
                                <Icon className="h-4 w-4 text-[#0e7be1] flex-shrink-0" data-id="element-114" />
                                {category.name}
                              </a>;
                      })}
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Resources Dropdown */}
            <div className="relative" onMouseEnter={() => handleDropdownEnter('resources')} onMouseLeave={() => {
            handleDropdownLeave();
            setActiveResourceCategory(null);
          }} data-id="element-115">
              <button className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium inline-flex items-center transition-colors" data-id="element-116">
                Resources
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${activeDropdown === 'resources' ? 'rotate-180' : ''}`} data-id="element-117" />
              </button>
              <div className={`absolute left-0 mt-0 pt-2 transition-all duration-150 ${activeDropdown === 'resources' ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`} data-id="element-118">
                <div className="bg-white shadow-xl ring-1 ring-gray-200 rounded-lg overflow-visible min-w-[260px]" data-id="element-119">
                  <div className="py-2" data-id="element-120">
                    {resourceCategories.map(category => <div key={category.name} className="relative" onMouseEnter={() => setActiveResourceCategory(category.name)} data-id="element-121">
                        <button className="w-full flex items-center justify-between px-4 py-2.5 text-sm font-medium text-gray-700 hover:text-[#0e7be1] hover:bg-gray-50 transition-colors text-left" data-id="element-122">
                          {category.name}
                          <ChevronRight className="h-4 w-4 text-gray-400" data-id="element-123" />
                        </button>

                        {/* Flyout Panel */}
                        {activeResourceCategory === category.name && <div className="absolute left-full top-0 ml-0 pl-1 w-[340px]" data-id="element-124">
                            <div className="bg-white shadow-xl ring-1 ring-gray-200 rounded-lg overflow-hidden" data-id="element-125">
                              <div className="py-2" data-id="element-126">
                                {category.links.map(link => <a key={link.name} href={link.url} className="block px-4 py-2.5 text-sm text-gray-600 hover:text-[#0e7be1] hover:bg-gray-50 transition-colors leading-snug" data-id="element-127">
                                    {link.name}
                                  </a>)}
                              </div>
                            </div>
                          </div>}
                      </div>)}

                    <div className="border-t border-gray-100 my-1" data-id="element-128"></div>

                    {directResourceLinks.map(item => <a key={item.name} href={item.url} className="block px-4 py-2.5 text-sm text-gray-600 hover:text-[#0e7be1] hover:bg-gray-50 transition-colors" data-id="element-129">
                        {item.name}
                      </a>)}
                  </div>
                </div>
              </div>
            </div>

            {/* About - Simple Link (no dropdown) */}
            <a href="/aboutus" className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium transition-colors" data-id="element-130">
              About
            </a>

            {/* Join Dropdown */}
            <div className="relative" onMouseEnter={() => handleDropdownEnter('join')} onMouseLeave={handleDropdownLeave} data-id="element-131">
              <button className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium inline-flex items-center transition-colors" data-id="element-132">
                Join
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${activeDropdown === 'join' ? 'rotate-180' : ''}`} data-id="element-133" />
              </button>
              <div className={`absolute left-0 mt-0 pt-2 transition-all duration-150 ${activeDropdown === 'join' ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`} data-id="element-134">
                <div className="bg-white shadow-xl ring-1 ring-gray-200 rounded-lg overflow-hidden min-w-[200px]" data-id="element-135">
                  <div className="py-2" data-id="element-136">
                    {joinItems.map(item => <a key={item.name} href={item.url} className="block px-4 py-2.5 text-sm text-gray-600 hover:text-[#0e7be1] hover:bg-gray-50 transition-colors" data-id="element-137">
                        {item.name}
                      </a>)}
                  </div>
                </div>
              </div>
            </div>
          </nav>

          {/* Right Side Info */}
          <div className="hidden lg:flex items-center space-x-4 text-sm" data-id="element-138">
            <a href="tel:800-260-2808" className="flex items-center text-gray-700 hover:text-[#0e7be1] font-medium transition-colors" data-id="element-139">
              <Phone className="h-4 w-4 mr-2 text-[#0e7be1]" data-id="element-140" />
              800-260-2808
            </a>
            <span className="text-gray-300" data-id="element-141">|</span>
            <a href="/contact-us" className="text-gray-600 hover:text-[#0e7be1] transition-colors" data-id="element-142">
              Contact
            </a>
            <span className="text-gray-300" data-id="element-143">|</span>
            <button className="text-gray-600 hover:text-[#0e7be1] transition-colors" aria-label="Member Login" data-id="element-144">
              <User className="h-5 w-5" data-id="element-145" />
            </button>
            <span className="text-gray-300" data-id="element-146">|</span>
            <a href="#" className="text-gray-600 hover:text-[#0e7be1] transition-colors" aria-label="Shopping Cart" data-id="element-147">
              <ShoppingCart className="h-5 w-5" data-id="element-148" />
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-149">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#0e7be1] hover:bg-gray-100 focus:outline-none" aria-label="Toggle menu" data-id="element-150">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-151" /> : <Menu className="h-6 w-6" data-id="element-152" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 max-h-[80vh] overflow-y-auto" data-id="element-153">
          <div className="px-4 py-3" data-id="element-154">
            {/* Products Section */}
            <div className="border-b border-gray-100 pb-2 mb-2" data-id="element-155">
              <button onClick={() => toggleMobileSection('products')} className="flex items-center justify-between w-full py-2.5 text-sm font-medium text-gray-800" data-id="element-156">
                Products
                <ChevronDown className={`h-4 w-4 transition-transform ${mobileExpandedSection === 'products' ? 'rotate-180' : ''}`} data-id="element-157" />
              </button>
              {mobileExpandedSection === 'products' && <div className="pl-4 space-y-0" data-id="element-158">
                  {productCategories.map(category => {
              const Icon = category.icon;
              return <a key={category.name} href={category.url} className="flex items-center gap-2 py-2 text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-159">
                        <Icon className="h-4 w-4 text-[#0e7be1] flex-shrink-0" data-id="element-160" />
                        {category.name}
                      </a>;
            })}
                </div>}
            </div>

            {/* Resources Section */}
            <div className="border-b border-gray-100 pb-2 mb-2" data-id="element-161">
              <button onClick={() => toggleMobileSection('resources')} className="flex items-center justify-between w-full py-2.5 text-sm font-medium text-gray-800" data-id="element-162">
                Resources
                <ChevronDown className={`h-4 w-4 transition-transform ${mobileExpandedSection === 'resources' ? 'rotate-180' : ''}`} data-id="element-163" />
              </button>
              {mobileExpandedSection === 'resources' && <div className="pl-4 space-y-1 mt-1" data-id="element-164">
                  {resourceCategories.map(category => <div key={category.name} className="mb-1" data-id="element-165">
                      <button onClick={() => setMobileExpandedResourceCategory(mobileExpandedResourceCategory === category.name ? null : category.name)} className="flex items-center justify-between w-full py-2 text-sm font-medium text-gray-700 hover:text-[#0e7be1]" data-id="element-166">
                        {category.name}
                        <ChevronDown className={`h-4 w-4 transition-transform ${mobileExpandedResourceCategory === category.name ? 'rotate-180' : ''}`} data-id="element-167" />
                      </button>
                      {mobileExpandedResourceCategory === category.name && <div className="pl-4 py-1 space-y-2 border-l-2 border-gray-100 ml-2 mt-1 mb-2" data-id="element-168">
                          {category.links.map(link => <a key={link.name} href={link.url} className="block text-sm text-gray-600 hover:text-[#0e7be1] leading-snug" data-id="element-169">
                              {link.name}
                            </a>)}
                        </div>}
                    </div>)}

                  <div className="border-t border-gray-100 my-2 mr-4" data-id="element-170"></div>

                  {directResourceLinks.map(item => <a key={item.name} href={item.url} className="block py-2 text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-171">
                      {item.name}
                    </a>)}
                </div>}
            </div>

            {/* About - Simple Link */}
            <a href="/aboutus" className="block py-2.5 text-sm font-medium text-gray-800 border-b border-gray-100 mb-2" data-id="element-172">
              About
            </a>

            {/* Join Section */}
            <div className="border-b border-gray-100 pb-2 mb-2" data-id="element-173">
              <button onClick={() => toggleMobileSection('join')} className="flex items-center justify-between w-full py-2.5 text-sm font-medium text-gray-800" data-id="element-174">
                Join
                <ChevronDown className={`h-4 w-4 transition-transform ${mobileExpandedSection === 'join' ? 'rotate-180' : ''}`} data-id="element-175" />
              </button>
              {mobileExpandedSection === 'join' && <div className="pl-4 space-y-0" data-id="element-176">
                  {joinItems.map(item => <a key={item.name} href={item.url} className="block py-2 text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-177">
                      {item.name}
                    </a>)}
                </div>}
            </div>

            {/* Contact Link */}
            <a href="/contact-us" className="block py-2.5 text-sm font-medium text-gray-700 hover:text-[#0e7be1]" data-id="element-178">
              Contact
            </a>
          </div>
        </div>}
    </header>;
}